// pico components
import { picoapp } from 'picoapp'
import ambassadorForm from '../components/ambassador-form'
import academyAnimations from '../components/academy-animations'
import academyForm from '../components/academy-form'
import academyKnowledge from '../components/academy-knowledge'
import alertBanner from '../components/alert-banner'
import wholesaler from '../components/wholesaler'
import blogCarousel from '../components/blog-carousel'
import featuredProductsCarousel from '../components/featured-products-carousel'
import landingPageStickyAtc from '../components/landing-page-sticky-atc'
import orderedCardsCarousel from '../components/ordered-cards-carousel'
import productAtf from '../components/product-atf'
import productBenefitTabs from '../components/product-benefit-tabs'
import productDeliveryDropdown from '../components/product-delivery-dropdown'
import productGallery from '../components/product-gallery'
import productSelectorDropdowns from '../components/product-selector-dropdowns'
import productsShowcaseCarousel from '../components/products-showcase-carousel'
import productUpsell from '../components/product-upsell'
import scrollTrackSlider from '../components/scroll-track-slider'
import sideMenuEvents from '../components/side-menu-events'
import sideMenuSlider from '../components/side-menu-slider'
import splideSlider from '../components/splide-slider'
import stickyAtc from '../components/sticky-atc'
import supplementFactsModal from '../components/supplement-facts-modal'
import supplementFactsModalLanding from '../components/supplement-facts-modal-landing'
import videoModule from '../components/video-module'
import videoModalHandler from '../components/video-modal-handler'
import videoOverlay from '../components/video-overlay'
import profilesSection from '../components/profiles-section'
import variantInputs from '../components/variant-inputs'
import testimonialCarousel from '../components/testimonial-carousel'
import curatedPlansCarousel from '../components/curated-plans-carousel'
import collectionFeaturedProductsCarousel from '../components/collection-featured-products-carousel'

const components = {
  ambassadorForm,
  academyAnimations,
  academyForm,
  academyKnowledge,
  alertBanner,
  wholesaler,
  blogCarousel,
  featuredProductsCarousel,
  landingPageStickyAtc,
  orderedCardsCarousel,
  productAtf,
  productBenefitTabs,
  productDeliveryDropdown,
  productGallery,
  productSelectorDropdowns,
  productUpsell,
  productsShowcaseCarousel,
  profilesSection,
  scrollTrackSlider,
  sideMenuEvents,
  sideMenuSlider,
  splideSlider,
  stickyAtc,
  supplementFactsModal,
  supplementFactsModalLanding,
  videoModule,
  videoModalHandler,
  videoOverlay,
  variantInputs,
  testimonialCarousel,
  curatedPlansCarousel,
  collectionFeaturedProductsCarousel,
}

export default picoapp(components)
